<template>
  <div class="w-full">
    <!-- Label:start -->
    <label v-if="label.trim() !== ''" class="form-label" :for="inputId">
      {{ label }}
    </label>
    <!-- Label:end -->

    <!-- Select:start -->
    <div
      class="input-group input-bg-theme-32 rounded relative"
      @focusin="isFocused = true"
      @focusout="isFocused = false"
    >
      <!-- Placeholder:start -->
      <span v-if="showPlaceholder" class="absolute left-3 top-2 text-gray-600 text-sm pointer-events-none">
        {{ placeholder }}
      </span>
      <!-- Placeholder:end -->

      <!-- Selected tags (static list):start -->
      <TomSelect
        ref="tomSelect"
        class="w-full cursor"
        :id="inputId"
        :disabled="disabled"
        :multiple="true"
        :plugins="['remove_button', 'dropdown_input']"
        v-model="internalValue"
      >
        <option v-for="item in items" :key="item[idKey]" :value="item[idKey]">
          {{ item[labelKey] }}
        </option>
      </TomSelect>
      <!-- Selected tags (static list):end -->
    </div>
    <!-- Select:end -->

    <!-- Error message:start -->
    <div v-if="error" class="text-theme-6 mt-2">
      {{ error }}
    </div>
    <!-- Error message:end -->
  </div>
</template>

<script>
export default {
  name: "SearchItemsList",
  props: {
    modelValue: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    idKey: { type: String, default: "id" },
    labelKey: { type: String, default: "name" },

    label: { type: String, default: "" },
    placeholder: { type: String, default: "Search items…" },
    disabled: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      isFocused: false,
      inputId: `sil-${global.crypto?.randomUUID?.() ?? Math.random().toString(36).slice(2)}`,
    };
  },
  computed: {
    // Normalizes to array and removes duplicates without type coercion
    internalValue: {
      get() {
        const v = this.modelValue;
        if (Array.isArray(v)) return v;
        if (v == null || v === "") return [];
        return [v];
      },
      set(val) {
        const arr = Array.isArray(val) ? val : val == null ? [] : [val];
        const dedup = Array.from(new Set(arr));
        this.$emit("update:modelValue", dedup);
      },
    },
    // Controls placeholder visibility
    showPlaceholder() {
      return !(this.internalValue && this.internalValue.length > 0) && !this.isFocused;
    },
  },
};
</script>
